import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice-btn-stop",
  "use": "icon-notice-btn-stop-usage",
  "viewBox": "0 0 53 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 51\" fill=\"none\" id=\"icon-notice-btn-stop\">\n  <circle cx=\"26.5\" cy=\"25.5\" r=\"23.5\" stroke=\"currentColor\" stroke-width=\"2\" />\n  <rect x=\"19\" y=\"19\" width=\"15\" height=\"13\" rx=\"1.5\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notice/notice-btn-stop.svg
// module id = IFMh
// module chunks = 24